
import { mapState } from 'vuex'
import { authorImage } from '@/utils/constants'

import EmailIcon from '@/static/svg/social/email-icon.svg'
import ChevronIcon from '@/static/svg/chevron-icon.svg'

export default {
  components: {
    EmailIcon,
    ChevronIcon,
  },
  data() {
    return {
      authorImage,
    }
  },
  computed: {
    ...mapState(['cdn']),
  },
  methods: {
    onAskOpticianClick() {
      this.$emit('ask-optician-clicked')
    },
  },
}
